import moment from "moment";

const state = {
  timeout: null,
  timeoutExpired: false,
  displayIsOn: false
};

const mutations = {
  STOP_DISPLAY_TIMER(state) {
    clearTimeout(state.timeout);
    state.timeout = null;
  },
  SET_DISPLAY_TIMER(state, t) {
    state.timeout = t;
  },
  SET_DISPLAY_IS_ON(state, status) {
    state.displayIsOn = status;
  }
};

const actions = {

  startDisplayOffTimer({ state, dispatch, commit, getters }) {

    const offTime = getters.getDisplayDriver.offTime;
    const obj = getters.getCurrentDaySchedule.find(
      scheduledItem => {
        if (
          scheduledItem.triggered === undefined ||
          scheduledItem.triggered === false
        ) {
          const scheduledItemTime = moment(scheduledItem.time, "HH:mm");
          const timeNow = moment();
          if (
            scheduledItemTime.diff(timeNow, "seconds") < 540 &&
            scheduledItemTime.diff(timeNow, "seconds") > 0
          ) {
            return true;
          } 
          return false;
          
        }
        return false;
      }
    );
    if (obj === undefined) {
      
      if (getters.getDisplayExists) {
        if (state.displayIsOn === false) {
          commit("SET_DISPLAY_IS_ON", true);
        }

        if (state.timeout === null) {

          const timeOut = setTimeout(() => {
            commit("STOP_DISPLAY_TIMER");
            commit("SET_DISPLAY_IS_ON", false);
            dispatch("setMessageWithTimeout", { message: "Display turning off", time: offTime * 1000 });
            dispatch("controlDisplay", "Power Off");
          }, 1000 * 60 * 1);

          commit("SET_DISPLAY_TIMER", timeOut);
        }
      }
    }
  },

  resetDisplayOffTimer({ state, dispatch, commit, getters }) {

    const offTime = getters.getDisplayDriver.offTime;

    if (state.timeout !== null) {

      commit("STOP_DISPLAY_TIMER");

      const t = setTimeout(() => {

        dispatch("setMessageWithTimeout", { message: "Display turning off", time: offTime * 1000 });
        commit("STOP_DISPLAY_TIMER");
        commit("SET_DISPLAY_IS_ON", false);
        dispatch("controlDisplay", "Power Off");
      }, 1000 * 60 * 1);

      commit("SET_DISPLAY_TIMER", t);
    }
  },

  stopDisplayOffTimer({ commit }) {
    commit("STOP_DISPLAY_TIMER");
  },
};

const getters = {
  getDisplayIsOn(state) {
    return state.displayIsOn;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/DisplayTimer.js